<template>
  <v-tooltip
    v-if="shouldTextBeTruncated"
    content-class="tooltip-text"
    transition="false"
    top
  >
    <template
      #activator="{ on, attrs }"
    >
      <div
        class="message-cell"
        v-bind="attrs"
        v-on="on"
      >
        {{ truncatedText }}
      </div>
    </template>
    <div
      class="message-cell"
      :style="textStyle"
    >
      {{ message }}
    </div>
  </v-tooltip>
  <div
    v-else
    class="message-cell"
    :style="textStyle"
  >
    {{ text }}
  </div>
</template>

<script>
import { isObject } from '@/global/utils/utils'

const DEFAULT_MAX_TEXT_LENGTH = 30
const DEFAULT_EMPTY_TEXT = ''
export default {
  name: 'TruncatedTextDisplay',

  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: null,
      default: null,
      validator: (value) => {
        return typeof value === 'string'
      }
    }
  },

  computed: {
    message () {
      return typeof this.data !== 'string' ? '' : this.data
    },

    maxTextLength () {
      return this.config?.maxTextLength ? this.config.maxTextLength : DEFAULT_MAX_TEXT_LENGTH
    },

    shouldTextBeTruncated () {
      return this.message.length > this.maxTextLength
    },

    textStyle () {
      return isObject(this.config?.textStyle) ? this.config.textStyle : {}
    },

    defaultEmptyText () {
      return this?.config?.defaultEmptyText !== undefined && typeof this.config.defaultEmptyText === 'string' ? this.config.defaultEmptyText : DEFAULT_EMPTY_TEXT
    },

    truncatedText () {
      return this.shouldTextBeTruncated ? this.message.slice(0, this.maxTextLength) + '...' : (this.message || this.defaultEmptyText)
    },

    text () {
      return this.message || this.defaultEmptyText
    }
  }
}
</script>

<style scoped>
.message-cell {
  font-family: 'Satoshi', sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
}

.tooltip-text {
  background-color: #F3F4F6 !important;
  color: #111827 !important;
  font-family: 'Satoshi', sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  border-radius: 8px;
  border: 1px solid #D1D5DB;
  padding: 8px 12px;
  box-shadow: none;
  max-width: 250px;
  white-space: normal;
  text-align: left;
  opacity: 1 !important;
}
</style>
